import { render, staticRenderFns } from "./OverviewRows.vue?vue&type=template&id=21df260c"
import script from "./OverviewRows.js?vue&type=script&lang=js&external"
export * from "./OverviewRows.js?vue&type=script&lang=js&external"
import style0 from "./OverviewRows.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports